import {
    accountCreatePost,
    accountDeleteDel,
    accountDetailsGet,
    accountListGet, accountTypeListGet,
    accountUpdatePut
} from "../Model/AccountModel";
import {del, get, post, put} from "../../../../GlobalModules/Utility/Http";

/**
 * Create a new account
 * @param {Object} accountData - Account data to create
 * @returns {Promise} Creation response
 */
export const createAccount = async (accountData) => {
    const response = await post(`${process.env.EXTENDED_URL}/account`, accountData);
    return accountCreatePost(response);
};

/**
 * Fetch account list with optional filters
 * @param {Object} filters - Filter parameters for the API call
 * @returns {Promise} Processed account list data
 */
export const getAccountList = async (filters = {}) => {
    // Format filters according to the API structure in Postman collection
    const queryParams = {
        filters: {
            store_id: filters.store_id || localStorage.getItem('store_id'),
            limit: filters.limit || 10,
            offset: filters.offset || 0,
        }
    };

    if (filters.is_billing !== undefined) {
        queryParams.filters.is_billing = filters.is_billing;
    }

    if (filters.start_date) {
        queryParams.filters.start_date = filters.start_date;
    }

    if (filters.end_date) {
        queryParams.filters.end_date = filters.end_date;
    }

    if (filters.search) {
        queryParams.filter_op = JSON.stringify({ search_attr: "substring" });
        queryParams.filters.search_attr = filters.search
    }

    if (filters.sort) {
        queryParams.filters.sort = filters.sort.map(item => ({
            colId: item.field,
            sort: item.sort
        }));
    }

    queryParams.filters = JSON.stringify(queryParams.filters);

    const response = await get(`${process.env.EXTENDED_URL}/account/list`, queryParams);

    return accountListGet(response)
}

/**
 * Fetch account type list
 * @returns {Promise} Processed account type list
 */
export const getAccountTypeList = async () => {
    const response = await get(`${process.env.EXTENDED_URL}/master_account_type`);
    return accountTypeListGet(response)
}

/**
 * Fetch single account details by ID
 * @param {string|number} id - Account ID
 * @returns {Promise} Processed account details
 */
export const getAccountDetails = async (id) => {
    const response = await get(`${process.env.EXTENDED_URL}/account/${id}`);
    return accountDetailsGet(response);
};

/**
 * Update an account
 * @param {string|number} slack - Account ID
 * @param {Object} stockTransferData - Updated account data
 * @returns {Promise} Update response
 */
export const updateMonthlyTarget = async (slack, stockTransferData) => {
    const response = await put(`${process.env.EXTENDED_URL}/account/${slack}`, stockTransferData);
    return accountUpdatePut(response);
};

/**
 * Delete account
 * @param {string|number} slack - Account ID
 * @returns {Promise} Delete response
 */
export const deleteAccount = async (slack) => {
    const response = await del(`${process.env.EXTENDED_URL}/account/${slack}`);
    return accountDeleteDel(response);
};